export const SHIPPING_GET_SINGLE_QUOTE_REQUESTED = 'SHIPPING_GET_SINGLE_QUOTE_REQUESTED';
export const SHIPPING_GET_SINGLE_QUOTE_SUCCEEDED = 'SHIPPING_GET_SINGLE_QUOTE_SUCCEEDED';
export const SHIPPING_GET_SINGLE_QUOTE_FAILED = 'SHIPPING_GET_SINGLE_QUOTE_FAILED';

export const SHIPPING_GET_CART_QUOTE_REQUESTED = 'SHIPPING_GET_CART_QUOTE_REQUESTED';
export const SHIPPING_GET_CART_QUOTE_SUCCEEDED = 'SHIPPING_GET_CART_QUOTE_SUCCEEDED';
export const SHIPPING_GET_CART_QUOTE_FAILED = 'SHIPPING_GET_CART_QUOTE_FAILED';

export const SHIPPING_GET_TRACKING_GUIDE_REQUESTED = 'SHIPPING_GET_TRACKING_GUIDE_REQUESTED';
export const SHIPPING_GET_TRACKING_GUIDE_SUCCEEDED = 'SHIPPING_GET_TRACKING_GUIDE_SUCCEEDED';
export const SHIPPING_GET_TRACKING_GUIDE_FAILED = 'SHIPPING_GET_TRACKING_GUIDE_FAILED';
